/**
 * Base URL for the public SENSCIENCE API. Override in `.env.local` for local
 * dev. An empty string means "same origin as the SPA", which is the right
 * default when the dev server proxies/mocks the API surface itself.
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL ?? 'https://api.sen.science';
